import {Button, Dialog, DialogContent, DialogTitle} from "@mui/material";
import PaperComponent from "../../../components/MuiDraggableDialog";
import MDTypography from "../../../components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import React, {useEffect, useState} from "react";
import MDBox from "../../../components/MDBox";
import brandLogo from "../../../assets/images/logos/darwynn/darwynn_no_text.svg";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {useDispatch} from "react-redux";
import {
    AuthActionType, get_auth_info, get_routes,
    getEmailCodeForForgetPW, getEmailCodeSignIn,
    getEmailCodeVerify, loginCodeVerify,
    onErrorAlert,
    onSuccessAlert
} from "../../../actions";
import MDInput from "../../../components/MDInput";
import MDButton from "../../../components/MDButton";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {addMapping} from "../../../actions/inventory/inventoryAction";
import {noop} from "lodash";
import LocalStorage from "../../../utils/LocalStorage";
import {findRoutes, keyToNodeMap} from "../../../utils/globalFunction";
import CircularProgress from "@mui/material/CircularProgress";
import {useTranslation} from "react-i18next";
const LoginVerification = ({loginVerificationOpen,setLoginVerificationOpen ,onLoginSuccess, email}) => {
    const dispatch = useDispatch()
    const {t, i18n} = useTranslation();
    const [code, setCode] = useState(Array(6).fill(''));
    const [seconds, setSeconds] = useState(0);
    const [show, setShow] = useState(true);
    const [isLoading,setIsLoading] = useState(false)
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
        }, 1000);
        if (seconds === 0) {
            setShow(false);
        } else {
            setShow(true)
        }

        return () => clearInterval(intervalId);
    }, [seconds]);


    const handleChange = (e, index) => {
        const value = e.target.value;
        if (value.length <= 1) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 5) {
                document.getElementById(`code-${index + 1}`).focus();
            }
        }
    };
    useEffect(() => {
        if (loginVerificationOpen === true){
            setCode(Array(6).fill(''));
            setSeconds(99); // 重置秒数
        }
    }, [loginVerificationOpen]);

    useEffect(() => {
        if (code?.length !== 0 && code.indexOf('') === -1 && code.length === 6) {
            handleLoginCodeVerify()
        }
    }, [code]);

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData('text').slice(0, 6);
        const newCode = pasteData.split('');
        while (newCode.length < 6) {
            newCode.push('');
        }
        setCode(newCode);

        const lastFilledIndex = newCode.findIndex((char, i) => char === '' || i === newCode.length - 1);
        document.getElementById(`code-${lastFilledIndex}`).focus();
    };

    const handleResendVerificationCode = async () => {
        setIsLoading(true)
        if (!!email) {
            await dispatch(getEmailCodeSignIn({email:email},onEmailResendSuccess,onError))
        }
    }

    const onEmailResendSuccess =() => {
        setIsLoading(false)
        dispatch(onSuccessAlert(t('SignInPage.Resend verification code successfully')))
        setSeconds(99);
    }

    const onError = async (msg) => {
        setIsLoading(false)
        dispatch(onErrorAlert(msg))
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !code[index]) {
            document.getElementById(`code-${index - 1}`).focus();
        }
    };

    const schema = yup
        .object({})

    const {register,
        setError,
        handleSubmit,
        getValues, setValue,
        clearErrors,
        formState: {errors}} = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    const onSubmit = (data) => {
        handleLoginCodeVerify()
    }

    const handleLoginCodeVerify = () => {
        setIsLoading(true)
        const formData = {};
        const verificationCode = code.join('');
        if(verificationCode!=='' && verificationCode.indexOf(' ') === -1 && verificationCode.length === 6){
            formData.emailAddress = email
            formData.emailCode = verificationCode
            const axiosPost= async () => {
                await dispatch(loginCodeVerify(formData,()=>{
                    onLoginSuccess()
                    setIsLoading(false)
                },onError))
            }
            axiosPost().then()
        }else {
            dispatch(onErrorAlert(t("SignInPage.Invalid verification code")))
            setIsLoading(false)
        }
    }


    const handleClose = () => {
        setCode(Array(6).fill(''));
        setLoginVerificationOpen(false)
    }

    const handleReset = () => {
        setCode(Array(6).fill(''));
        //setLoginVerificationOpen(false)
    }

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'xs'}
                open={loginVerificationOpen}
                onClose={handleReset}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            ><DialogTitle id="draggable-dialog-title" style={{cursor: 'move', display: 'flex', justifyContent: 'flex-end' , alignItems: "center"}}>
            </DialogTitle>
                <DialogContent>
                    <MDBox
                        component="form" role="form" onSubmit={handleSubmit(onSubmit)}
                        sx={{display: 'flex', justifyContent: 'space-between',flexDirection: "column"}}>
                        <MDBox
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="success"
                            p={2}
                            sx={{display: 'flex', alignItems: "center", justifyContent: "center"}}>
                            <MDBox mr={2}>
                                <img src={brandLogo} width="80px" alt=""/>
                            </MDBox>
                            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                                {t('SignInPage.Verify login code')}
                            </MDTypography>
                        </MDBox>
                        <MDBox pr={2} pl={2} mt={4} sx={{fontWeight: 'bold'}}>
                            {t('SignInPage.Welcome back!')}
                        </MDBox>
                        <MDBox pr={2} pl={2}>
                            {t('SignInPage.There is one more step to verify.')}
                        </MDBox>
                        <MDBox p={2}>
                            {t('SignInPage.For additional security, please enter the 6-digit code we sent to your email')} {email? `:${email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, "$1***@$2")}` :"" }.
                        </MDBox>
                        <MDBox component="form" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                            <MDBox sx={{ display: 'flex', gap: 1 }} onPaste={handlePaste}>
                                {code.map((digit, index) => (
                                    <MDInput
                                        key={index}
                                        id={`code-${index}`}
                                        value={digit}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        InputProps={{autoComplete: 'off',maxLength: 1, style: { textAlign: 'center' }}}
                                        autoFocus={index === 0}
                                        sx={{
                                            width: '40px', height: '20px', '& .MuiOutlinedInput-input': {
                                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                    '-webkit-appearance': 'none',
                                                }
                                            }
                                        }}
                                    />
                                ))}
                            </MDBox>
                        </MDBox>
                        <MDBox pl={2} pr={2} mt={4} display="flex" alignItems="center" justifyContent="start">
                            <MDTypography display="block" variant="button">
                                {t(`ForgotPasswordPage.Haven't receive a code?`)}
                            </MDTypography>
                            <Button sx={{padding: 1}} onClick={handleResendVerificationCode}
                                    disabled={show}>{t('Resend')}</Button>
                            <MDTypography display="block" variant="button">
                                {show && `${seconds}s`}
                            </MDTypography>
                        </MDBox>
                        <MDBox pl={2} pr={2} mt={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                            <MDBox mr={1}>
                                <MDButton variant="outlined" color="info" onClick={handleClose}>
                                    {t('Cancel')}
                                </MDButton>
                            </MDBox>
                            {/* <MDBox mr={1}>
                                <MDButton variant="gradient" color="info" type='submit' disabled={isLoading}>
                                    {
                                        // isLoading ?
                                        //     <CircularProgress  size="20px" thickness={5}  color="inherit"/>
                                        //     :
                                            "sign in"
                                    }
                                </MDButton>
                            </MDBox> */}
                        </MDBox>
                    </MDBox>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default LoginVerification